import { httpConfig } from './config';
import { Http } from './http';

export const http = new Http(httpConfig);
